/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jan 09 2025
 **/

import { useState } from "react";

import { useEventHandlers } from "@rfice/eventhandler";

import { IDrawingData } from "@/types/types";
import NetworkPlayerIndicator from "./NetworkPlayerIndicator";

export default function NetworkPlayerIndicators() {
	const [players, setPlayers] = useState<{ [key: string]: IDrawingData }>({});

	useEventHandlers(
		{
			onNetworkPlayerStart: (id: string, data: IDrawingData) => {
				setPlayers((prev) => ({
					...prev,
					[id]: data
				}));
			}
		},
		[players]
	);
	return (
		<>
			{Object.entries(players).map(
				([key, player]) => Object.keys(player).length !== 0 && <NetworkPlayerIndicator key={key} {...player} />
			)}
		</>
	);
}
